export const FETCH_STATS = 'FETCH_STATS'
export const RECEIVE_STATS = 'RECEIVE_STATS'
